const handleMobileMegamenu = () => {
  $(".menu__item--has-dropdown").on("click", "> a", function (event) {
    if ($(window).innerWidth() >= 768) {
      return;
    }

    const $this = $(this);
    const $parent = $this.closest("li");
    const $nav = $this.closest(".nav");

    $this.siblings().slideToggle();

    $nav.find("li.is-open").css("background-color", "");

    $this.closest("li").toggleClass("is-open");

    $this
      .closest("li")
      .siblings()
      .removeClass("is-open")
      .find(".megamenu")
      .slideUp();

    if ($this.hasClass("highlight") && $parent.hasClass("is-open")) {
      $this.closest("li").css("background-color", $parent.data("color"));
    }

    event.preventDefault();
  });
};

handleMobileMegamenu();
